import moment from 'moment';
export const getTime = () => {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
};
export const ensureMoment = (value) => {
    if (!value)
        return null;
    if (moment.isMoment(value))
        return value;
    if (typeof value === 'string')
        return moment.utc(value.substr(0, 10));
    if (value instanceof Date)
        return moment.utc(value);
    return null;
};
export const toISODate = (value) => {
    if (!value)
        return null;
    if (moment.isMoment(value))
        return value.format('YYYY-MM-DD');
    if (value instanceof Date)
        return moment.utc(value).format('YYYY-MM-DD');
    if (typeof value === 'string')
        return value.substr(0, 10);
    return null;
};
export const getHoursMinutesFromTime = (time) => {
    if (Number.isNaN(time))
        return '';
    const sign = time < 0 ? '-' : '';
    const value = Math.abs(time);
    const h = Math.floor(value / 60);
    const m = value % 60;
    return `${sign}${h}:${m < 10 ? '0' : ''}${m}`;
};
